import React from 'react';
import { Container } from '@/components/ui/Container';

export function IconChipButton({ ariaLabel, disabled, onClick, children }) {
    return (
        <button
            type="button"
            aria-label={ariaLabel}
            disabled={disabled}
            onClick={onClick}
            style={{
                border: '1px solid var(--ant-color-border-secondary, #f0f0f0)',
                background: disabled
                    ? 'var(--ant-color-fill-quaternary, rgba(0,0,0,0.02))'
                    : 'var(--ant-color-bg-elevated, #fff)',
                color: disabled ? 'var(--ant-color-text-tertiary, rgba(0,0,0,0.35))' : 'var(--ant-color-text, rgba(0,0,0,0.88))',
                height: 28,
                minWidth: 28,
                padding: '0 10px',
                borderRadius: 999,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: disabled ? 'not-allowed' : 'pointer',
                transition: 'background 160ms ease, border-color 160ms ease, opacity 160ms ease',
            }}
            onMouseEnter={(e) => {
                if (disabled) return;
                e.currentTarget.style.borderColor = 'var(--ant-color-border, #d9d9d9)';
                e.currentTarget.style.background = 'var(--ant-color-fill-quaternary, rgba(0,0,0,0.02))';
            }}
            onMouseLeave={(e) => {
                if (disabled) return;
                e.currentTarget.style.borderColor = 'var(--ant-color-border-secondary, #f0f0f0)';
                e.currentTarget.style.background = 'var(--ant-color-bg-elevated, #fff)';
            }}
        >
            <Container $display="inline-flex" $alignItems="center" $justifyContent="center" style={{ lineHeight: 0 }}>
                {children}
            </Container>
        </button>
    );
}

